export const answerClick = (data) => {
    if (typeof window !== "undefined") {
      window.gtag("event", data['answers']);
    }
};
export const buttonClick = (name)=>{
  if (typeof window !== "undefined") {
    window.gtag("event", name);
  }
}